export default __webpack_public_path__ + "static/media/videocam.27f5dc44.svg";